import React, { use, useEffect, useState } from 'react';
import { PostTag } from '../PostTag';
import Container from '../Container';
import { WalletButton } from '../WalletButton';
import { useAccount } from 'wagmi';


const TopSection: React.FC<{ isMember: any }> = ({ isMember }) => {
  const { address } = useAccount();
  return (
    <div className='relative py-[40px] pt-[100px] sm:py-[80px] sm:pt-[100px] px-[12px]'>
        <Container className="flex flex-col items-center justify-start text-white">
          {
            address && !isMember && (
              <div className="flex flex-col flex-wrap items-center gap-[8px]">
              <PostTag className="mr-[8px] bg-white w-fit text-gray-950 p-[8px]">
                <div>Launch</div>
              </PostTag>
              <PostTag className="bg-teal-400 text-[#222] w-fit">
                <div className="inline-flex items-center">
                  <img 
                    src="/soul/icon-star.svg" 
                    alt="48CLUB" 
                    className="w-[48px]"
                  />
                  Your Journey
                  <img 
                    src="/soul/icon-star.svg" 
                    alt="48CLUB" 
                    className="w-[24px] sm:w-[48px]"
                  />
                </div>
              </PostTag>
              <PostTag className="mr-[8px] w-fit bg-pink-400 text-gray-950 p-[8px]">
                <div>Now</div>
              </PostTag>
            </div>
            )
          }
          {
            address && isMember && (
              <div className="flex flex-col flex-wrap items-center gap-[8px]">
              <PostTag className="mr-[8px] bg-white w-fit text-gray-950 p-[8px]">
                <div>Collect</div>
              </PostTag>
              <PostTag className="bg-[#FEC84B] text-[#222] w-fit">
                <div className="inline-flex items-center">
                  <img 
                    src="/soul/icon-soul-black.svg" 
                    alt="48CLUB" 
                    className="w-[24px] sm:w-[48px]"
                  />
                  48 Soul Point
                  <img 
                    src="/soul/icon-soul-black.svg" 
                    alt="48CLUB" 
                    className="w-[24px] sm:w-[48px]"
                  />
                </div>
              </PostTag>
              <PostTag className="mr-[8px] w-fit bg-[#B692F6] text-gray-950 p-[8px]">
                <div>ASAP</div>
              </PostTag>
            </div>
            )
          }
          {
            !address && (
              <div className="w-full flex flex-col gap-[8px]">
                <div className="flex flex-wrap items-start leading-tight">
                  <PostTag bgColor="#fff" color="#171412" className="mr-[8px] text-[#222]">
                    <div>Launch</div>
                  </PostTag>
                  <PostTag className="bg-yellow-400 text-[#222]">
                    <div className="inline-flex items-center">
                      <img 
                        src="/soul.svg" 
                        alt="48CLUB" 
                        className="w-[24px] sm:w-[48px]"
                      />
                      48 Soul Point
                    </div>
                  </PostTag>
                  <div className="text-white bg-[#44403C] text-xs rounded-[100px] px-[8px] py-[4px] text-16 ml-[8px] hidden sm:block">NEW</div>
                </div>
                <div className="flex flex-wrap items-start leading-tight">
                  <PostTag bgColor="#fff" color="#171412" className='mr-[8px] text-[#222]'>Participate in</PostTag>
                  <div className="text-white bg-[#44403C] text-xs rounded-[100px] px-[8px] py-[4px] text-16 ml-[8px] block sm:hidden">OUR</div>
                  <PostTag bgColor="#2ED3B7" color="gray-950" className="text-gray-950">
                    <div className="flex items-center">
                      <img 
                        src="/hand.svg" 
                        alt="48CLUB" 
                        className="w-[24px] sm:w-[48px]"
                      />
                      48 Club
                    </div>
                  </PostTag>
                </div>
                <div className="flex flex-wrap items-center leading-tight">
                  <PostTag bgColor="#F670C7" color="#222" className="mr-[8px] text-gray-950">
                    <div className="flex items-center">
                      <img 
                        src="/flower.svg" 
                        alt="48CLUB" 
                        className="w-[24px] sm:w-[48px]"
                      />
                      Ecosystem
                    </div>
                  </PostTag>
                </div>
                <div className="mt-10">
                {/* 这里可以放 Connect Wallet 按钮等 */}
                <WalletButton />
              </div>
            </div>
            )
          }
        </Container>
      </div>
  );
};

export default TopSection; 